import React from "react";
import {useDispatch, useSelector} from "react-redux";
import {useTheme} from "../../../../../connectui/theme/ThemeProvider";
import {buildStyles} from "../../../../../connectui/component/buildStyles";
import Text from "../../../../../connectui/component/display/Text";
import DropdownExpand from "../../../../../connectui/component/display/dropdown/DropdownExpand";
import FlexContainer from "../../../../../connectui/component/layout/FlexContainer";
import ICONS from "connectui/icons/iconMap";
import SvgIcon from "../../../../../connectui/component/display/SvgIcon";
import ListComponent from "../../../../../connectui/component/layout/list/ListComponent";
import Tooltip from "../../../../../connectui/component/display/Tooltip";
import {useHistory} from "react-router-dom";
import BookingStatusField from "../../../field/fields/BookingStatusField";
import ListItemContainer from "../../../../../connectui/component/layout/list/ListItemContainer";
import Container from "../../../../../connectui/component/layout/Container";
import Skeleton from "../../../../../connectui/component/display/Skeleton";
import {useTranslation} from "react-i18next";
import {
  getGuest,
  getInboxData,
} from "../../../../../redux/actions/guestsActions";
import {useFlags} from "launchdarkly-react-client-sdk";

const useStyles = (theme) =>
  buildStyles({
    houseName: {
      maxWidth: "200px",
      overflow: "hidden",
      cursor: "pointer",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    },
  });

export default function FollowingSection({guestId}) {
  const {theme, isMobile} = useTheme();
  const classes = useStyles(theme);
  const guests = useSelector((state) => state.defaultReducer.guests_dict);
  let guest = guests[guestId];
  const [expanded, setExpanded] = React.useState(true);
  const searchParams = new URLSearchParams(window.location.search);
  const viewId = searchParams.get("view_id");
  const history = useHistory();
  const {t} = useTranslation();
  const dispatch = useDispatch();
  const flag = useFlags();

  return (
    <DropdownExpand
      divider={false}
      expanded={expanded}
      onExpand={() => setExpanded(!expanded)}
      customLabel={
        <FlexContainer alignItems="center" gap={theme.spacing(2)}>
          <Text variant={"textLG"} weight="semibold">
            {t("inbox.guest-details.following.header")}
          </Text>
        </FlexContainer>
      }
    >
      <FlexContainer flexDirection={"column"} gap={theme.spacing(3)}>
        {!guest?.bookings ? (
          <ListComponent gap={theme.spacing(1)} sx={{width: "100%"}}>
            {Array.from({length: 7}).map((_, index) => (
              <Skeleton key={index} width={"100%"} height={"44px"} />
            ))}
          </ListComponent>
        ) : !guest?.following_metadata ||
          guest?.following_metadata?.length === 0 ? (
          <FlexContainer
            alignItems="center"
            justifyContent="center"
            sx={{width: "100%", height: "300px"}}
          >
            <Text variant="textSM" color="gray500">
              {t("inbox.guest-details.following.no-guests")}
            </Text>
          </FlexContainer>
        ) : (
          <ListComponent gap={theme.spacing(1)} sx={{width: "100%"}}>
            {guest?.following_metadata?.map((f) => (
              <Tooltip
                colors={{bg: "gray900", text: "white"}}
                tooltipContent={
                  <Text variant="textXS" color={"white"}>
                    {t("inbox.guest-details.following.view-conversation", {
                      name: f?.name,
                    })}
                  </Text>
                }
              >
                <ListItemContainer
                  key={f.guest_id}
                  onClick={() => {
                    if (f.guest_id) {
                      dispatch(
                        getGuest(f.guest_id, () => {
                          if (flag.newInboxViewUnreadCounts) {
                            dispatch(getInboxData());
                          }
                        }),
                      );
                      history.push(
                        `/admin/messages/${isMobile ? "chat/" : ""}${f.guest_id}${
                          viewId !== null ? `?view_id=${viewId}` : ""
                        }`,
                      );
                    }
                  }}
                  itemProps={{
                    sx: {
                      borderRadius: 0,
                    },
                  }}
                >
                  <FlexContainer
                    flexDirection={"column"}
                    gap={theme.spacing(2)}
                    sx={{width: "100%", cursor: "pointer"}}
                  >
                    <FlexContainer
                      alignItems={"flex-start"}
                      justifyContent={"space-between"}
                      sx={{width: "100%"}}
                    >
                      <Text
                        as="div"
                        variant="textSM"
                        weight="medium"
                        color="gray700"
                      >
                        {f?.name}
                      </Text>
                      <BookingStatusField
                        fieldData={{val: f?.booking_status || "Unknown"}}
                        type="display"
                      />
                    </FlexContainer>

                    <FlexContainer>
                      <Tooltip
                        tooltipContent={
                          <Container sx={{maxWidth: "300px"}}>
                            <Text
                              variant="textSM"
                              color="white"
                              sx={{
                                whiteSpace: "normal",
                                wordWrap: "break-word",
                                overflowWrap: "break-word",
                              }}
                            >
                              {f?.destinations || "No bookings"}
                            </Text>
                          </Container>
                        }
                        enterDelay={500}
                        leaveDelay={0}
                        colors={{bg: "gray900", text: "white"}}
                        sx={{
                          trigger: {
                            flex: 1,
                            overflow: "hidden",
                            whiteSpace: "nowrap",
                          },
                          tooltip: {padding: theme.spacing(2)},
                        }}
                      >
                        <Text
                          variant="textXS"
                          weight="medium"
                          color="textSecondary"
                          className={classes.houseName}
                        >
                          {f?.destinations || "No bookings"}
                        </Text>
                      </Tooltip>
                      {f?.range_formatted && (
                        <FlexContainer alignItems={"center"}>
                          <SvgIcon
                            component={ICONS.calendar}
                            sx={{
                              color: theme.colors.textSecondary,
                              width: "12px",
                              height: "12px",
                              marginRight: theme.spacing(1),
                            }}
                          />
                          <Text
                            variant="textXS"
                            weight="medium"
                            color="textSecondary"
                          >
                            {f?.range_formatted?.replace("to", "→")}
                          </Text>
                        </FlexContainer>
                      )}
                    </FlexContainer>
                  </FlexContainer>
                </ListItemContainer>
              </Tooltip>
            ))}
          </ListComponent>
        )}
      </FlexContainer>
    </DropdownExpand>
  );
}
